import { connect } from 'react-redux';
import { curry } from 'lodash/fp';

import ContainerCard from './ContainerCard';
import getContainerLabel from '../../../../helpers/getContainerLabel';

import containerPricing from '../../../../services/designPricing/container';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { containers, items, estimates } = estimateBuilder.entities;
  const { selectedEstimate } = estimateBuilder.uiState;
  const container = containers.byId[ownProps.containerId];
  const { name } = container;
  const { isLockedOrOrdered } = estimates.byId[selectedEstimate];
  const { isMandi } = estimates.byId[selectedEstimate].attributes || false;
  const { isAutoReleaseDesign } = estimates.byId[selectedEstimate].attributes || false;

  const sumContainerItemsByProp = containerPricing(items.byId, curry.placeholder, container);

  const retail = sumContainerItemsByProp('retail');
  const subtotal = sumContainerItemsByProp('subtotal');

  const label = container.charLabel || getContainerLabel(ownProps.index);

  return {
    name,
    label,
    retail,
    subtotal,
    isLockedOrOrdered,
    isMandi,
    isAutoReleaseDesign: isAutoReleaseDesign === 'true',
  };
};

export default connect(mapStateToProps)(ContainerCard);
